import React, { PropTypes as T } from 'react';
import { TransitionMotion, spring } from 'react-motion';
import { Segment, Header, Icon } from 'semantic-ui-react';
import _ from 'lodash';
import BrowserDetection from 'react-browser-detection';
import BrowserHandler from '../../utils/browser-handler';
import ThemeSelector from '../../themes/theme-selector';
import PoweredByDyzio from '../../components/powered-by-dyzio';

const CORQ_DOMAIN = 'data.corq.studio';

export default class HomePage extends React.Component {
  static contextTypes = {
    router: T.object,
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      items: [],
    };
  }

  componentDidMount() {
    this.setState({
      items: [{ key: 'a', opacity: 1 }],
    });
  }

  willEnter() {
    return { opacity: 0 };
  }

  render() {
    const theme = ThemeSelector.theme();
    const isWhiteLabel = ThemeSelector.isWhiteLabel();
    const { hostname } = window.location;
    const isDyzio = _.eq(_.get(window, 'origin'), 'https://app.dyzio.co');

    const isCORQ = (hostname === CORQ_DOMAIN);

    const imageStyle = theme.darkLogo.size ? { height: theme.darkLogo.size } : null;

    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) && !isDyzio;

    return (
      <div className="page-centered">
        <div className="center-outer">
          <div className="center-inner">
            <div className="center-logo">
              <img src={theme.darkLogo.src} alt={theme.darkLogo.alt} style={imageStyle} />
            </div>

            <BrowserDetection>
              {BrowserHandler.safariHandle}
            </BrowserDetection>

            {
              isCORQ
                ? <Segment placeholder textAlign="center">
                  <Header icon>
                    <Icon name="lock" />
                      You have been logged out...
                  </Header>
                  <p>Head back to <a href="https://test.corq.studio">CORQ Studio</a> to log in.</p>
                </Segment>
                :
                <TransitionMotion
                  willEnter={this.willEnter}
                  defaultStyles={this.state.items.map(item => ({ key: item.key, style: { opacity: 0 } }))}
                  styles={this.state.items.map(item => ({
                    key: item.key,
                    style: { opacity: spring(item.opacity, { stiffness: 240, damping: 40 }) },
                  }))}
                >
                  { interpolatedStyles => (
                    <div>
                      {interpolatedStyles.map(config => (
                        <div className="center-content" key={config.key} style={{ ...config.style }}>
                          <button disabled={isSafari} className="large rose stretch" onClick={() => this.context.router.push('/login')}>
                            <p>Log In</p>
                          </button>
                          {!theme.hideSignup && (<div>
                            <div className="option-separator">
                              <div className="left" />
                              <div className="center">
                                <p>OR</p>
                              </div>
                              <div className="right" />
                            </div>
                            <button disabled={isSafari} className="large rose stretch" onClick={() => this.context.router.push('/company/signup')}>
                              <p>Sign Up</p>
                            </button>
                          </div>)}
                        </div>
                      ))}
                    </div>
                  )}
                </TransitionMotion>
            }


            <div className="browser-detect">
              <PoweredByDyzio />
              <BrowserDetection>
                {BrowserHandler.handle}
              </BrowserDetection>
            </div>

          </div>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/containers/homepage/index.js
 **/